import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    formIndicator: {
        display: "flex",
        flexDirection: "column",
        padding: "0 var(--formBodyH)",
    },
    formIndicatorContent: {
        display: "flex",
        flexDirection: "column",
        padding: "0 ",
    },
}));
